import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  SupplierItemRateFun,
  SupplierProItemRate,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Supplier/SupplierSlice";
import { CustomerSupplierProAcDetail } from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function MonthlyItemRate({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { SupplierItemRatedata } = useSelector((state) => state.SupplierSlice);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  // useEffect(() => {
  //   dispatch(SupplierItemRateFun());
  //   dispatch(
  //     SupplierProItemRate({
  //       Firm,
  //       Year: YearId,
  //       AcIDs: accountName.join(","),
  //       selectedIds: accountGroup.join(","),
  //       startDate: startDate,
  //       endDate: endDate,
  //     }),
  //   );
  //   dispatch(
  //     CustomerSupplierProAcDetail({
  //       AcIDs: accountName,
  //     }),
  //   );
  // }, [dispatch, Firm, YearId, accountName]);

  useEffect(() => {
    dispatch(SupplierItemRateFun());

    dispatch(
      SupplierProItemRate({
        Firm,
        Year: YearId,
        AcIDs: accountName?.join(",") || "",
        selectedIds: accountGroup?.join(",") || "",
        startDate,
        endDate,
      }),
    );

    dispatch(
      CustomerSupplierProAcDetail({
        AcIDs: accountName,
      }),
    );
  }, [dispatch, Firm, YearId, accountName, accountGroup, startDate, endDate]);

  const getRows = SupplierItemRatedata?.Detail?.map((label, index) => ({
    chart: true,
    // srNumber: index + 1,
    ItemName: label.ItemName,
    AprRate: label.AprRate,
    MayRate: label.MayRate,
    JunRate: label.JunRate,
    JulRate: label.JulRate,
    AugRate: label.AugRate,
    SepRate: label.SepRate,
    OctRate: label.OctRate,
    NovRate: label.NovRate,
    DecRate: label.DecRate,
    JanRate: label.JanRate,
    FebRate: label.FebRate,
    MarRate: label.MarRate,
    Rate: label.Rate,
    HighRate: label.HighRate,
    LowRate: label.LowRate,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Avg Rate",
      key: "Rate",
      format: "true",
      align: "right",
    },
    {
      label: "High Rate",
      key: "HighRate",
      format: "true",
      align: "right",
    },
    {
      label: "low Rate",
      key: "LowRate",
      format: "true",
      align: "right",
    },
    {
      label: "Apr ",
      key: "AprRate",
      format: "true",
      align: "right",
    },
    {
      label: "May ",
      key: "MayRate",
      format: "true",
      align: "right",
    },
    {
      label: "Jun ",
      key: "JunRate",
      format: "true",
      align: "right",
    },
    {
      label: "Jul ",
      key: "JulRate",
      format: "true",
      align: "right",
    },
    {
      label: "Aug ",
      key: "AugRate",
      format: "true",
      align: "right",
    },
    {
      label: "Sep ",
      key: "SepRate",
      format: "true",
      align: "right",
    },
    {
      label: "Oct ",
      key: "OctRate",
      format: "true",
      align: "right",
    },
    {
      label: "Nov ",
      key: "NovRate",
      format: "true",
      align: "right",
    },
    {
      label: "Dec ",
      key: "DecRate",
      format: "true",
      align: "right",
    },
    {
      label: "Jan ",
      key: "JanRate",
      format: "true",
      align: "right",
    },
    {
      label: "Feb ",
      key: "FebRate",
      format: "true",
      align: "right",
    },
    {
      label: "Mar ",
      key: "MarRate",
      format: "true",
      align: "right",
    },
  ];

  if (SupplierItemRatedata === "no" || SupplierItemRatedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  const columns = [
    { key: "company", label: "Company" },
    { key: "branch", label: "Branch" },
    { key: "itemName", label: "Item" },
    { key: "itemCode", label: "Code" },
    { key: "category", label: "Category" },
    { key: "unit", label: "Unit", align: "center" },
    { key: "openingMeters", label: "Opening", align: "right", format: true },
    { key: "stockQty", label: "Stock", align: "right", format: true },
    { key: "rate", label: "Rate (₹)", align: "right", format: true },
    { key: "amount", label: "Amount (₹)", align: "right", format: true },
    { key: "status", label: "Status", align: "center" },
  ];
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,

            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY ITEM RATE
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
